// extracted by mini-css-extract-plugin
export default {"input":"login-form_input__gh8Pj","submit-button":"login-form_submit-button__jzJwX"};